import { QuotationsActionTypes } from "./quotationsTypes";
const initialState = {
    list: []
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case QuotationsActionTypes.FETCH_QUOTATIONS_SUCCESS:
            return Object.assign(Object.assign({}, state), { list: action.payload });
        default:
            return state;
    }
};
export { reducer as quotationsReducer };
